import React from 'react';

const Stepper = ({ currentStep, steps = [], onStepClick }) => {
    return (
        <div className="bg-gray-50/50 border-b border-gray-200 px-8 py-3">
            <div className="flex justify-between items-center max-w-3xl mx-auto">
                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isCompleted = currentStep > stepNumber;
                    const isActive = currentStep === stepNumber;
                    const label = typeof step === 'string' ? step : step.label;

                    return (
                        <div
                            key={index}
                            className={`flex items-center gap-2 ${onStepClick ? 'cursor-pointer' : ''}`}
                            onClick={() => onStepClick && onStepClick(stepNumber)}
                        >
                            <div
                                className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold transition-colors duration-200 ${isActive
                                    ? "bg-indigo-500 text-white shadow-md ring-2 ring-sky-100"
                                    : isCompleted
                                        ? "bg-green-500 text-white"
                                        : "bg-gray-200 text-gray-500"
                                    }`}
                            >
                                {isCompleted ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                ) : (
                                    stepNumber
                                )}
                            </div>
                            <span
                                className={`hidden sm:block text-sm font-medium ${isActive ? "text-blue-900" : "text-gray-400"
                                    }`}
                            >
                                {label}
                            </span>
                            {index < steps.length - 1 && (
                                <div className="hidden sm:block w-12 h-0.5 bg-gray-200 mx-2"></div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Stepper;